import { USER_REGISTER_360, USER_REGISTER_360_SUCCESS, USER_REGISTER_360_ERROR, USER_REGISTER_360_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UserRegister360 = (state = initialState, action) => {
  switch (action.type) {
    case USER_REGISTER_360:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case USER_REGISTER_360_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case USER_REGISTER_360_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case USER_REGISTER_360_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UserRegister360;
